export default function debounce(
  duration: number,
  proc: (...args: any[]) => any,
) {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      proc(...args);
    }, duration);
  };
}
